module.exports = __webpack_public_path__ + "static/media/15_crisalide.406ac2b5.jpg";